export default function computedStyle(node, pseudoElement) {
    return window.getComputedStyle(node, pseudoElement);
}
